import { createLazyReactDirective } from '../shell/createLazyReactDirective';

export default createLazyReactDirective(
  async () => (await import('./LeadContainer')).LeadContainer,
  'leadContainer',
  {
    routeParams: '=',
  },
);
